<script>
export default {
  name: "TurnoverStatusCard",
  props: {
    details: {
      type: Object,
      default: null
    },
    message: {
      type: String,
      default: ""
    }
  },
  computed: {
    ratioLabel() {
      if (!this.details) return "2/3";
      return `${this.details.turnoverNumerator || 2}/${this.details
        .turnoverDenominator || 3}`;
    }
  },
  methods: {
    money(value) {
      return new Intl.NumberFormat("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(value) || 0);
    }
  }
};
</script>

<template>
  <section class="turnover-status" role="alert" aria-live="assertive">
    <div class="turnover-status__heading">
      <span class="turnover-status__icon" aria-hidden="true">!</span>
      <div>
        <h2 class="turnover-status__title">ยังถอนไม่ได้</h2>
        <p class="turnover-status__message">
          {{ message || "ยอดเล่นที่ระบบนับยังไม่ครบตามเกณฑ์" }}
        </p>
      </div>
    </div>

    <dl v-if="details" class="turnover-status__summary">
      <div class="turnover-status__row">
        <dt>เครดิตเข้าเงื่อนไข</dt>
        <dd>{{ money(details.eligibleCredit) }} บาท</dd>
      </div>
      <div class="turnover-status__row turnover-status__row--required">
        <dt>เกณฑ์ถอน ({{ ratioLabel }})</dt>
        <dd>{{ money(details.required) }} บาท</dd>
      </div>
      <div class="turnover-status__row">
        <dt>ยอด Valid Amount</dt>
        <dd>{{ money(details.validAmt) }} บาท</dd>
      </div>
      <div class="turnover-status__row turnover-status__row--remaining">
        <dt>เหลือต้องทำอีก</dt>
        <dd>{{ money(details.remaining) }} บาท</dd>
      </div>
    </dl>

    <p v-if="details" class="turnover-status__note">
      นับเฉพาะเดิมพันที่สมบูรณ์ตามเงื่อนไข (Valid Amount)
      รายการยกเลิกหรือไม่สมบูรณ์อาจไม่นับ
    </p>
    <p
      v-if="details && details.checkedAtText"
      class="turnover-status__checked-at"
    >
      ตรวจสอบล่าสุด {{ details.checkedAtText }} น.
    </p>
  </section>
</template>

<style lang="scss" scoped>
.turnover-status {
  margin-bottom: 1rem;
  padding: 1rem;
  border: 1px solid rgba(245, 158, 11, 0.45);
  border-radius: 12px;
  background: linear-gradient(
    145deg,
    rgba(245, 158, 11, 0.14),
    rgba(127, 29, 29, 0.16)
  );
  color: #fff;

  &__heading {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    border-radius: 50%;
    background: #f59e0b;
    color: #1c1200;
    font-weight: 800;
  }

  &__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: #fde68a;
  }

  &__message {
    margin: 0.2rem 0 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 0.85rem;
    line-height: 1.5;
  }

  &__summary {
    margin: 1rem 0 0;
    padding: 0.8rem;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.22);
  }

  &__row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.35rem 0;
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.83rem;

    dt,
    dd {
      margin: 0;
    }

    dd {
      color: #fff;
      font-weight: 650;
      text-align: right;
    }

    &--required dd {
      color: #fde68a;
    }

    &--remaining {
      margin-top: 0.35rem;
      padding-top: 0.7rem;
      border-top: 1px solid rgba(255, 255, 255, 0.1);

      dd {
        color: #fca5a5;
      }
    }
  }

  &__note,
  &__checked-at {
    margin: 0.75rem 0 0;
    color: rgba(255, 255, 255, 0.56);
    font-size: 0.74rem;
    line-height: 1.5;
  }

  &__checked-at {
    margin-top: 0.3rem;
  }
}
</style>
